import axios from 'axios';
export const backendserverurl ='https://orochurchcommunitysacco-3378449bk-01.pitech.co.ug'

// Normalize DRF detail URLs: `/api/<resource>/<id>` -> `/api/<resource>/<id>/`
axios.interceptors.request.use((config) => {
  if (!config || !config.url) return config;

  const url = String(config.url);

  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : '';
  if (token && url.includes('/customqueries/')) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Token ${token}`;
    }
  }

  const apiMarker = '/api/';
  if (!url.includes(apiMarker)) return config;

  const qIdx = url.indexOf('?');
  const pathOnly = qIdx >= 0 ? url.slice(0, qIdx) : url;
  const queryPart = qIdx >= 0 ? url.slice(qIdx) : '';

  if (pathOnly.endsWith('/')) return config;

  const detailPathRe = /\/api\/[-A-Za-z0-9_]+\/[^/]+$/;
  if (!detailPathRe.test(pathOnly)) return config;

  config.url = `${pathOnly}/${queryPart}`;
  return config;
});

export const memberDetailUrl = (memberId) => `${backendserverurl}/api/members/${memberId}/`

//http://127.0.0.1:8000/

//http://165.227.183.69:10225

//https://echnewsaas-9242363bk-01.pitech.co.ug  --pisacco demo
//https://ends4efinancialservices-6394327bk-01.pitech.co.ug --frnds
//pctsacco-7099212bk-01.pitech.co.ug --kca
//https://sasacco-5111608bk-01.pitech.co.ug/ --UMI

//sacco-2278373bk-01.pitech.co.ug	--ksgu
//
//

//entaletradersfinancialservices-2017596bk-01.pitech.co.ug


//https://orochurchcommunitysacco-3378449bk-01.pitech.co.ug/
